import _ from 'lodash';

// 同步表单项module
export default function createSyncPlugin(namespace) {
  return (store) => {
    store.dispatch(`${namespace}/initVuexModule`);
    store.watch((state, getters) => getters[`${namespace}/formData4View`], (newVal, oldVal) => {
      if (!_.isEqual(newVal, oldVal)) {
        store.dispatch(`${namespace}/fillForm`, newVal);
      }
    }, {
      deep: true,
    });
  };
}
